import { AddIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Heading,
  Tag,
} from "@chakra-ui/react";
import { forwardRef } from "react";
import { useFieldArray } from "react-hook-form";
import { CaseProRulesItem } from "./CaseProRulesItem";

const CaseProcessingRules = forwardRef(({ control, name }, ref) => {
  const { fields: rules, prepend, remove } = useFieldArray({ control, name });

  return (
    <Box
      p={4}
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      bg="gray.50"
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
        shadow="sm"
      >
        <Heading size="md" color="blue.700">
          ⚙️ Rules Editor
        </Heading>
        <Button
          colorScheme="teal"
          leftIcon={<AddIcon />}
          onClick={() =>
            prepend({
              TYPE: "RULE",
              ID: `NEW_${Date.now()}`,
              CONDITION: { Field: "", Operator: "==", Value: "" },
              TRUE_STEP: [],
              FALSE_STEP: [],
            })
          }
        >
          Add Rule
        </Button>
      </Box>

      {/* Rules list */}
      <Accordion allowMultiple>
        {rules.map((rule, i) => (
          <AccordionItem key={rule.id || `rule-${i}`} border="none">
            <AccordionButton
              _expanded={{ bg: "blue.50" }}
              px={4}
              py={3}
              borderRadius="md"
              shadow="xs"
            >
              <Box
                flex="1"
                textAlign="left"
                fontWeight="semibold"
                color="blue.700"
              >
                {rule.ID || `Rule ${i + 1}`}{" "}
                <Tag ml={2} size="sm" colorScheme="blue">
                  {rule.TYPE || "RULE"}
                </Tag>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel px={0} pt={3}>
              <CaseProRulesItem
                control={control}
                path={`${name}.${i}`}
                rule={rule}
                remove={() => remove(i)}
                depth={0}
              />
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
});

export default CaseProcessingRules;
